import useCache from "@/common/hook/useCache";
import CacheKeys from "@/common/models/CacheKeys";

export default function useChatReceiverId() {
  return useCache(CacheKeys.CHAT_RECEIVER_ID);
}
